import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../lib/auth";
import { formatApiError } from "../../lib/api";
import { Wordmark, GoldDivider, Eyebrow } from "../../components/brand";
import { LOGO } from "../../content/site";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/altura-command/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await login(email, password);
      navigate("/altura-command/dashboard");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="page-admin-login">
      <div className="flex flex-col justify-center bg-altura-ivory px-10 lg:px-20 py-14">
        <img src={LOGO.iconOnly} alt="Altura" className="h-12 w-12" />
        <Eyebrow className="mt-8">Altura Command Center</Eyebrow>
        <h1 className="mt-3 font-editorial text-4xl text-altura-espresso">Sign in.</h1>
        <p className="mt-2 text-sm text-altura-charcoal/60">Executive Operations Platform</p>
        <GoldDivider className="mt-6" />
        <form onSubmit={submit} className="mt-8 space-y-4 max-w-md">
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-altura-charcoal/60">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="admin-input mt-1" data-testid="login-email" />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-altura-charcoal/60">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                   className="admin-input mt-1" data-testid="login-password" />
          </div>
          <button type="submit" disabled={busy} className="btn-gold w-full disabled:opacity-60" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-8 text-xs text-altura-charcoal/50 max-w-md">
          The Command Center is restricted to authorized Altura Global personnel. All activity is logged for audit purposes.
        </p>
      </div>
      <div className="hidden lg:block relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1778731525532-d2ab833c8463?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-altura-espresso/85 via-altura-espresso/40 to-transparent" />
        <div className="absolute inset-0 flex items-end p-14 text-altura-ivory">
          <div>
            <div className="eyebrow text-altura-gold">Altura Global</div>
            <div className="mt-3 font-editorial text-4xl leading-tight max-w-md">A quiet workspace for a considered practice.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
